import { fetchWrapper } from "_helpers";

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_CONTEXT_PATH}`;

export const creditVoucherService = {
  getAll,
  create,
  getSuggestion,
  search,
  getById,
};

function getAll() {
  return fetchWrapper.get(`${baseUrl}/creditVouchers`);
}
function create(params) {
  return fetchWrapper.post(`${baseUrl}/creditVouchers`, params);
}

function getById(id) {
  return fetchWrapper.get(`${baseUrl}/creditVouchers/${id}`);
}

function getSuggestion(params) {
  return fetchWrapper.get(`${baseUrl}/creditVouchers/suggestion${params}`);
}

function search(params) {
  return fetchWrapper.get(`${baseUrl}/creditVouchers${params}`);
}
